<template>
    <div class="p-3">
        <el-card header="Banners publicitarios">
            <PersonalTable :loading="loading" :height="450" :showRows="10" :cols="[
                {label: 'Nome', prop: 'title'},
                {label: 'link', prop: 'url'},
                {label: 'Ordem', prop: 'position'},
                {label: 'Texto', prop: 'small_text'},
            ]" :data="data" >
                <el-table-column label="Expira em" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ new Date(data.row.expires_at).toLocaleString() }}
                    </template>
                </el-table-column>
                <el-table-column label="Cadatrado em" class-name="auto" :min-width="100">
                    <template #default="data">
                        {{new Date(data.row.created_at).toLocaleString()}}
                    </template>
                </el-table-column>
                <el-table-column label="Acções" class-name="auto">
                    <template #default="data">
                        <span class="p-2">
                            <el-button @click="openAdBanner(data.row)" type="primary" icon="View" title="Ver mais"></el-button>
                        </span>
                        <span class="p-2">
                            <el-button type="danger" icon="Delete" title="Eliminar" @click="deleteBanner(data.row.id)"></el-button>
                        </span>
                    </template>
                </el-table-column>
            </PersonalTable>
        </el-card>
    </div>
    <ElDialog v-model="showDialog" show-close @close="hide">
        <AdBannerView v-if="adBanner" :ad-banner="adBanner" @close="hide" />
    </ElDialog>
</template>

<script lang="ts" setup>
    import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElDialog, ElMessageBox } from 'element-plus';
    import { useStore } from 'vuex';
    import { AdBanner } from '@/services/types/adBanner';
    import AdBannerView from '@/components/modals/views/AdBannerView.vue';

    const loading = ref<boolean>(true)
    const showDialog = ref<boolean>(false)
    const data = ref<Array<AdBanner>>()
    const adBanner = ref<AdBanner | null>(null)

    const getAdBanners = async () => {
        const res = await Api.get('/admin/ad-banners')
        if (res.status == 200) {
            data.value = res.data.adBanners
            console.log(res)
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
    }

    const openAdBanner = (a: AdBanner) => {
        showDialog.value = true
        adBanner.value = a
    }

    const hide = (a?: AdBanner) => {
        if (a) {
            const toEdit = data.value?.find((ad) => ad.id == a.id)
            if (toEdit) {
                toEdit.description = a.description
                toEdit.expires_at = a.expires_at
                toEdit.image = a.image
                toEdit.position = a.position
                toEdit.small_text = a.small_text
                toEdit.title = a.title
                toEdit.updated_at = a.updated_at
                toEdit.url = a.url
            }
        }
        showDialog.value = false
        adBanner.value = null
    }
    
    const deleteBanner = async (id: number) => {
        loading.value = true
        if (confirm('Deseja realmente eliminar?')) {
            const res = await Api.delete(`/admin/ad-banners/${id}`)
            if (res.status == 200) {
                await getAdBanners()
            } else {
                ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
            }
        }
        loading.value = false
    }

    onBeforeMount(async () => {
        await getAdBanners()
        loading.value = false
    })

    const store = useStore()
    store.watch((s, g) => g.openModal, async (val, oldVal) => {
        if (oldVal == 1) {
            await getAdBanners()
        }
    })
</script>

<style lang="scss">
    .auto {
        min-width: 100px;
        width: auto !important;
        &>* {
            min-width: 100px;
            width: auto !important;
        }
    }
</style>
